import GridViewIcon from '@mui/icons-material/GridView'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted'

const ViewToggle = ({ value, onChange, className }) => {
    return (
        <div className={`viewToggle ${className || ''}`}>
            <button
                type="button"
                className={`viewToggle__btn ${value === 'plate' ? 'is-active' : ''}`}
                onClick={() => onChange('plate')}
                aria-label="Плитка"
            >
                <GridViewIcon />
            </button>
            <button
                type="button"
                className={`viewToggle__btn ${value === 'list' ? 'is-active' : ''}`}
                onClick={() => onChange('list')}
                aria-label="Список"
            >
                <FormatListBulletedIcon />
            </button>
        </div>
    )
}

export default ViewToggle
